import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar el rol",
    opening: localizedGenderNode(
      [
      "Hoy no intento cambiar el rol.",
      "Solo lo noto.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento cambiar el rol.",
      "Solo lo noto.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo siento que solo escucho?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo siento que solo escucho?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar el rol ya es un comienzo."
    ],
      [
      "Notar el rol ya es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que se queda en mí",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que se queda en mí después de escuchar.",
      "Sin juicio.",
      "Solo ver."
    ],
      [
      "Hoy noto lo que se queda en mí después de escuchar.",
      "Sin juicio.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué no suelo decir?",
      "¿Qué guardo dentro?",
      "¿Cómo me afecta?"
    ],
      [
      "¿Qué no suelo decir?",
      "¿Qué guardo dentro?",
      "¿Cómo me afecta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo que se queda en mí importa."
    ],
      [
      "Lo que se queda en mí importa."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que se queda.",
      "escribir una palabra sobre lo que se queda."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Por qué elijo escuchar",
    opening: localizedGenderNode(
      [
      "Hoy pregunto por qué elijo escuchar tanto.",
      "No crítica.",
      "Curiosidad."
    ],
      [
      "Hoy pregunto por qué elijo escuchar tanto.",
      "No crítica.",
      "Curiosidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué obtengo cuando escucho?",
      "¿Qué temo perder si hablo?",
      "¿Qué necesidad hay debajo?"
    ],
      [
      "¿Qué obtengo cuando escucho?",
      "¿Qué temo perder si hablo?",
      "¿Qué necesidad hay debajo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Hay una razón suave detrás de escuchar."
    ],
      [
      "Hay una razón suave detrás de escuchar."
    ]
    ),
    action: localizedGenderNode(
      "nombrar una necesidad pequeña.",
      "nombrar una necesidad pequeña."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Un lugar para mi voz",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo dar lugar a mi voz.",
      "Pequeño.",
      "Seguro."
    ],
      [
      "Hoy observo cómo dar lugar a mi voz.",
      "Pequeño.",
      "Seguro."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento la garganta."
    ],
      [
      "Respiro despacio.",
      "Siento la garganta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde puedo darme espacio para hablar?",
      "¿Qué temo decir?",
      "¿Qué paso pequeño puedo dar?"
    ],
      [
      "¿Dónde puedo darme espacio para hablar?",
      "¿Qué temo decir?",
      "¿Qué paso pequeño puedo dar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño lugar para mi voz ya cambia algo."
    ],
      [
      "Un pequeño lugar para mi voz ya cambia algo."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase que quiera salir.",
      "escribir una frase que quiera salir."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo a cargar",
    opening: localizedGenderNode(
      [
      "Hoy noto el miedo a cargar.",
      "No para pelear.",
      "Solo ver."
    ],
      [
      "Hoy noto el miedo a cargar.",
      "No para pelear.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué tengo miedo cuando comparto?",
      "¿Qué creo que pasará si hablo?",
      "¿Cómo me protege este miedo?"
    ],
      [
      "¿De qué tengo miedo cuando comparto?",
      "¿Qué creo que pasará si hablo?",
      "¿Cómo me protege este miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo a cargar también es un deseo de cuidar la conexión."
    ],
      [
      "El miedo a cargar también es un deseo de cuidar la conexión."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Un equilibrio pequeño",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo crear un equilibrio pequeño.",
      "No perfecto.",
      "Solo pequeño."
    ],
      [
      "Hoy observo cómo crear un equilibrio pequeño.",
      "No perfecto.",
      "Solo pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde doy más de lo que recibo?",
      "¿Qué me gustaría recibir un poco más?",
      "¿Qué paso pequeño puedo dar?"
    ],
      [
      "¿Dónde doy más de lo que recibo?",
      "¿Qué me gustaría recibir un poco más?",
      "¿Qué paso pequeño puedo dar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un equilibrio pequeño puede devolver energía."
    ],
      [
      "Un equilibrio pequeño puede devolver energía."
    ]
    ),
    action: localizedGenderNode(
      "escribir una petición pequeña.",
      "escribir una petición pequeña."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Quedarme cuando hablo",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme cuando hablo.",
      "No desaparecer.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme cuando hablo.",
      "No desaparecer.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me apresuro a terminar?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ],
      [
      "¿Cuándo me apresuro a terminar?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento más puede cambiar algo."
    ],
      [
      "Un momento más puede cambiar algo."
    ]
    ),
    action: localizedGenderNode(
      "pausar 10 segundos antes de retirarme.",
      "pausar 10 segundos antes de retirarme."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una palabra mía",
    opening: localizedGenderNode(
      [
      "Hoy elijo una palabra mía para compartir.",
      "No mucho.",
      "Una palabra."
    ],
      [
      "Hoy elijo una palabra mía para compartir.",
      "No mucho.",
      "Una palabra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué palabra quiere salir de mí?",
      "¿A quién me gustaría decirla?",
      "¿Cómo se sentirá decirla?"
    ],
      [
      "¿Qué palabra quiere salir de mí?",
      "¿A quién me gustaría decirla?",
      "¿Cómo se sentirá decirla?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra puede abrir una puerta."
    ],
      [
      "Una palabra puede abrir una puerta."
    ]
    ),
    action: localizedGenderNode(
      "escribir la palabra y recordarla.",
      "escribir la palabra y recordarla."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Una petición",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña.",
      "No una exigencia.",
      "Una petición."
    ],
      [
      "Hoy formulo una petición pequeña.",
      "No una exigencia.",
      "Una petición."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me gustaría pedir con suavidad?",
      "¿Cómo puedo decirlo con dulzura?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué me gustaría pedir con suavidad?",
      "¿Cómo puedo decirlo con dulzura?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede cambiar el ritmo."
    ],
      [
      "Una petición puede cambiar el ritmo."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Sentirme escuchado/a",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué me hace sentir escuchado/a.",
      "Pequeño.",
      "Pero importante."
    ],
      [
      "Hoy pregunto qué me hace sentir escuchado/a.",
      "Pequeño.",
      "Pero importante."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Estoy aquí."
    ],
      [
      "Respiro despacio.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo se siente cuando me escuchan de verdad?",
      "¿Qué me gustaría recibir allí?",
      "¿Qué paso pequeño podría ayudar?"
    ],
      [
      "¿Cómo se siente cuando me escuchan de verdad?",
      "¿Qué me gustaría recibir allí?",
      "¿Qué paso pequeño podría ayudar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Sentirme escuchado/a es una necesidad real."
    ],
      [
      "Sentirme escuchado/a es una necesidad real."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que necesito escuchar.",
      "escribir una palabra sobre lo que necesito escuchar."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor en la conexión",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor que llevo a la conexión.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor que llevo a la conexión.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor me importa en la conexión?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor me importa en la conexión?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor es un hilo de presencia."
    ],
      [
      "Un valor es un hilo de presencia."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Escucharme también",
    opening: localizedGenderNode(
      [
      "Hoy practico escucharme también.",
      "No solo a otros.",
      "También a mí."
    ],
      [
      "Hoy practico escucharme también.",
      "No solo a otros.",
      "También a mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ],
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Escucharme es un pequeño arreglo."
    ],
      [
      "Escucharme es un pequeño arreglo."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de reciprocidad",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de reciprocidad.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de reciprocidad.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para moverme."
    ],
      [
      "Un paso pequeño es suficiente para moverme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la reciprocidad.",
      "Cuando me olvido de mí.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la reciprocidad.",
      "Cuando me olvido de mí.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mi escucha?",
      "¿Cuál es la primera señal de que desaparezco?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre mi escucha?",
      "¿Cuál es la primera señal de que desaparezco?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo escuchar a otros y aun así quedarme conmigo."
    ],
      [
      "Puedo escuchar a otros y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const iMAlwaysTheOneWhoListensToEveryoneButWhoListensToMeBlueprintEs = buildNormalizedPilotBlueprint({
  id: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me",
  category: "loneliness_belonging",
  journeyName: {
    he: "אני תמיד זה שמקשיב לכולם - אבל מי מקשיב לי?",
    en: "I'm always the one who listens to everyone - but who listens to me?",
    es: "Siempre soy quien escucha a todos - ¿pero quién me escucha a mí?",
  },
  days,
});

export default iMAlwaysTheOneWhoListensToEveryoneButWhoListensToMeBlueprintEs;
